import React from 'react'

export default function Table({ tableHeadingdata, children }) {
    return (
        <>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-800 uppercase bg-gray-300 dark:text-gray-800">
                        <tr>
                            {
                                tableHeadingdata.map((item, index) => (
                                    <th key={index} scope="col" className={`px-6 py-3 ${item === '#' ? 'w-1' : item === 'Action' ? 'text-center w-40' : ''}`}>
                                        {item}
                                    </th>
                                ))
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {children}
                    </tbody>
                </table>
            </div>

        </>
    )
}
